import { v4 as uuidv4 } from 'uuid';

const getHeaderService = () => ({
    "Transaccion-Id"                : uuidv4(),
    "Aplicacion-Id"                 : process.env.REACT_APP_APLICACION_ID,
    "Nombre-Aplicacion"             : process.env.REACT_APP_NOMBRE_APLICACION,
    "Usuario-Consumidor-Id"         : process.env.REACT_APP_USUARIO_CONSUMIDOR_ID,
    "Nombre-Servicio-Consumidor"    : process.env.REACT_APP_NOMBRE_SERVICIO_CONSUMIDOR_ID,
    "Ocp-Apim-Subscription-Key"     : process.env.REACT_APP_OCP_APIM_KEY,
    "Authorization"                 : sessionStorage.getItem("infoToken")
});

export const HeadersMapping = {
    "getHeaderService"          : getHeaderService
};
